// extracted by mini-css-extract-plugin
export default {"card":"W1-z","carouselContainer":"X1-z","carouselContent":"Y1-z"};